import { FC } from 'react';

import SunshineCard from 'components/_core/SunshineCard';
import { IconName as SunshineIconName } from 'components/_core/SunshineIcon';
import SquircleIcon from 'components/_core/SunshineSquircleIcon';

interface ActionProps {
  icon: SunshineIconName;
  title: string;
  description: string;
  onClick: () => void;
}

const Action: FC<ActionProps> = ({ description, icon, onClick, title }) => (
  <SunshineCard onClick={onClick}>
    <SunshineCard.Slot name="aside">
      <SquircleIcon name={icon} />
    </SunshineCard.Slot>

    <SunshineCard.Content>
      <SunshineCard.Title>{title}</SunshineCard.Title>
      <SunshineCard.Text>{description}</SunshineCard.Text>
    </SunshineCard.Content>

    <SunshineCard.Slot name="action">
      <SunshineCard.SunshineIcon name="chevron-right" />
    </SunshineCard.Slot>
  </SunshineCard>
);

export default Action;
